export const DEFAULT_TOKEN_LIST_URL = 'pancakeswap'
export const GEMINI_LIST = 'https://www.gemini.com/uniswap/manifest.json'

export const DEFAULT_LIST_OF_LISTS: string[] = [DEFAULT_TOKEN_LIST_URL, GEMINI_LIST]
